export default "__VITE_ASSET__1c561754__"